import introJs from 'intro.js'
import 'intro.js/introjs.css'

export const tourSteps = () => {
  console.log('helloxxxx');

  // Define intro instance at the top so it's accessible everywhere in this function
  const intro = introJs();

  // Function to configure & start the tour
  const startTour = () => {
    localStorage.setItem('isTourActive', 'true');

    intro.setOptions({
      doneLabel: 'Finish',
      hidePrev: true,
      showBullets: false,
      showProgress: true,
      autoPosition: false,
      disableInteraction: true,
      exitOnOverlayClick: false,
      scrollTo: 'tooltip',
      tooltipClass: 'welcome-tooltip',
      steps: [
        {
          intro: `
            <div class="intro">
              <div class="content">
                <h3>Welcome to Sparkle Time Keeping!</h3>
                <p>Let's walk you through the app so you can clock in, clock out, and manage your shifts with ease.</p>
              </div>
            </div>
          `,
          position: 'bottom',
        },
        {
          element: '#newShift',
          title: '<strong>Start a New Shift</strong>',
          intro: `
            <p>Tap this button to begin a new shift. Your time-in will be recorded automatically, 
            so you can keep track of your work hours with ease.</p>
          `,
          position: 'bottom',
        },
      ],
    });

    const clearTourFlag = () => {
      localStorage.removeItem('isTourActive'); // ✅ Clear when finished
      console.log('Tour ended → isTourActive removed');
    };

    // Add before-exit behavior
    intro.onBeforeExit(() => {
      clearTourFlag();
      // document.cookie = 'introjs-dontShowAgain=true; path=/';
      localStorage.setItem('dontShowIntro', 'true');
    });

    // Add click-to-next overlay handler
    const handleOverlayClick = () => intro.nextStep();

    // Attach event listener once tour is started
    intro.onAfterChange(() => {
      console.log("HERE")
      const overlayElement = document.querySelector('.introjs-overlay');
      console.log(overlayElement)
      if (overlayElement) {
        overlayElement.removeEventListener('click', handleOverlayClick); // prevent duplicates
        overlayElement.addEventListener('click', handleOverlayClick);
      }
    });

    intro.start();

    intro.oncomplete(() => {
    const newShiftBtn = document.querySelector('#newShift');
    if (newShiftBtn) {
      newShiftBtn.addEventListener('click', waitForTimeInTour);
    }
  });
  };

  const waitForTimeInTour = () => {
    const waitForTimeIn = setInterval(() => {
      const timeInBtn = document.querySelector('#confirmBtn'); // <-- Change to your actual ID
      if (timeInBtn) {
        clearInterval(waitForTimeIn);

        // Scroll into view first
        timeInBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

        setTimeout(() => {
          const intro2 = introJs();
          intro2.setOptions({
            steps: [
              {
                element: '#confirmBtn',
                title: '<strong>Confirm Schedule</strong>',
                intro: `
                  <p>Great! Let's lock in your schedule. 
                  By confirming, you're all set to start your shift and track your time smoothly.</p>
                `,
                position: 'left',
              },
              {
                element: '#timein', // your button selector
                title: '<strong>Time In</strong>',
                intro: `
                  <p>Tap here to clock in and officially start tracking your shift. 
                  Your time will be recorded right away.</p>
                `,
                position: 'top',
              },
              {
                element: '#timeout',
                title: '<strong>End Your Shift</strong>',
                intro: `
                  <p>All done? Tap this button to time out and wrap up your shift. 
                  Your total hours will be saved automatically.</p>
                `,
                position: 'top',
              },
            ],
            scrollTo: 'tooltip',
            disableInteraction: true,
            tooltipClass: 'welcome-tooltip',
            exitOnOverlayClick: false,

          });

          const handleOverlayClick = () => intro.nextStep();

    // Attach event listener once tour is started
          intro2.onAfterChange(() => {
            const overlayElement = document.querySelector('.introjs-overlay');
            if (overlayElement) {
              overlayElement.removeEventListener('click', handleOverlayClick); // prevent duplicates
              overlayElement.addEventListener('click', handleOverlayClick);
            }
          });

          intro2.start();
        }, 500); // small delay for smooth scroll
      }
    }, 100);
  };


  // Wait until #newShift exists before starting
  const waitForElement = setInterval(() => {
    const el = document.querySelector('#newShift');
    if (el) {
      // Force scroll into view before starting intro
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      clearInterval(waitForElement);

      // Give extra time for scroll animation to finish
      setTimeout(() => startTour(), 1000);
    }
  }, 2000);
};
